import { sortAscending } from 'assets/svg-strings/sort-ascending'
import { sortDescending } from 'assets/svg-strings/sort-descending'

export const blotterColumnSortIcons = { sortAscending, sortDescending }
